import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { useCallback } from 'react';

function NomineeDeleteDetails({ selectedDistCode, selectedRemarks }) {

    const [data, setData] = useState([]);
    const [message, setMessage] = useState("");
    const [selectedRcs, setSelectedRcs] = useState([]);
    const [statusmessage, setStatusMessage] = useState("");

    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(() => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_URL}/api/DeleteNominee/getrcs`, {
            params: {
                distCode: selectedDistCode,
                remarks: selectedRemarks
            }
        })
            .then(res => {
                if (res.data && res.data.data && res.data.data.length > 0) {
                    setData(res.data.data);
                    setMessage(res.data.message);
                } else {
                    setData([]);
                    setMessage(res.data.message || "No Data Available");
                }
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    }, [selectedDistCode, selectedRemarks]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // ✔ Checkbox Selection
    const handleCheck = (rcId) => {

        if (selectedRcs.includes(rcId)) {
            setSelectedRcs(selectedRcs.filter(rc => rc !== rcId));
        } else {
            setSelectedRcs([...selectedRcs, rcId]);
        }
    };

    // ✔ Delete Selected RCs
    const handleDelete = () => {

        if (selectedRcs.length === 0) {
            alert("Please select Cards");
            return;
        }

        if (!window.confirm("Are you sure you want to delete nominees For Selected Cards?"))
            return;

        setLoading(true);
        axios.post(`${process.env.REACT_APP_URL}/api/DeleteNominee/delete`,
            selectedRcs, {
            headers: { 'X-React-Route': window.location.href }
        }
        )
            .then(res => {
                setStatusMessage(res.data.Status);
                alert(res.data.Status);
                // Re-fetch data to reflect actual server state (showing any failed deletions)
                // We reuse the existing useEffect logic by relying on the component re-rendering or just calling the fetch again. 
                // However, directly calling the fetch logic is cleaner here.
                fetchData();
                setSelectedRcs([]);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    };

    return (
        <div>

            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {data.length > 0 ? (
                        <>
                            <table border="1" align="center" width="60%">
                                <thead>
                                    <tr className='tableheader'><th colSpan={5}>{message}</th></tr>
                                    <tr className='tableheader'>
                                        <th>Select</th>
                                        <th>FPS ID</th>
                                        <th>RC ID</th>
                                        <th>Enabled Date</th>
                                        <th>Scheme</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        data.map((row, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        onChange={() => handleCheck(row.rc_id)}
                                                        checked={selectedRcs.includes(row.rc_id)}
                                                    />
                                                </td>
                                                <td>{row.fps_id}</td>
                                                <td>{row.rc_id}</td>
                                                <td>{row.formatted_date}</td>
                                                <td>{row.scheme_name_en}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                            <br />

                            <center>
                                <button className="button button2" onClick={handleDelete}>
                                    Remove Selected RCs
                                </button>
                            </center>
                        </>
                    ) : (
                        <div className='response' align='center'>
                            <p>{message}</p>
                        </div>
                    )}

                    {statusmessage && (
                        <div className='response' align='center'>
                            <p>{statusmessage}</p>
                        </div>
                    )}
                </>
            )}

        </div>
    )
}

export default NomineeDeleteDetails
